/**
 * Per-environment API URL prefix for the Activity iframe.
 *
 * Discord proxies all outbound requests from the iframe through `/.proxy/*`
 * with a strict allowlist. Inside the Discord client the iframe runs on a
 * `*.discordsays.com` host; outside (local dev / direct browser visit) it
 * runs on `discord.runhuman.com` (or localhost via Vite). The prefix flips
 * based on hostname so the same code path works both ways — used by every
 * `fetch(...)` call in the SPA *and* by `<img src>` attributes that need to
 * hit the API (the avatar proxy in particular).
 */
export const apiPrefix: string = (() => {
  if (typeof window === 'undefined') return '/api';
  if (window.location.hostname.endsWith('.discordsays.com')) return '/.proxy/api';
  return '/api';
})();
